<script>
import { ScrappedReasonServiceProxy } from '@/service-proxies/app-v2/qc.service-proxies'
const srsp = new ScrappedReasonServiceProxy()

export default {
  data() {
    return {
      data: [],
      count: 1,
      scrapReasons: [],
      columns :  [
        {
          title: this.$t('page_plan_scrap_number'),
          dataIndex: 'scrappedNum',
          scopedSlots: { customRender: 'scrappedNum' }
        },
        {
          title: this.$t('page_scrap_type'),
          dataIndex: 'scrappedType',
          scopedSlots: { customRender: 'scrappedType' }
        },
        {
          title: this.$t('page_scrap_reason'),
          dataIndex: 'scrappedReason',
          scopedSlots: { customRender: 'scrappedReason' }
        },
        {
          title: this.$t('page_ops_machine_operate'),
          width: 100,
          scopedSlots: { customRender: 'action' }
        }
      ]
    }
  },
  props: {
    scrapType: {
      type: Array,
      default: () => []
    },
    scrapNumber: {
      type: Number,
      default: 0
    }
  },
  methods: {
    handleChange(value, key, column) {
      let num = value
      this.data
        .filter((item) => key !== item.key)
        .forEach((res) => {
          num = res.scrappedNum + num
        })
      if (column === 'scrappedNum' && num > this.scrapNumber) {
        this.$message.warning(this.$t('page_scrap_tip1'))
      }
      const newData = [...this.data]
      const target = newData.filter((item) => key === item.key)[0]

      if (target) {
        if (column === 'scrappedType') {
          const type = this.scrapType.find((res) => res.code === value)
          target['scrappedTypeCode'] = type.code
          target[column] = type.name
          target['scrappedReason'] = ''
          target['scrappedReasonCode'] = ''
        } else if (column === 'scrappedReason') {
          const reasons = target.scrapReasons.find((res) => res.code === value)
          target['scrappedReasonCode'] = reasons.code
          target[column] = reasons.reason
        } else {
          target[column] = value
        }
        this.data = newData
        this.$emit('changeData', this.data)
      }
    },
    async getReasons(record) {
      const type = this.scrapType.find((res) => res.code === record.scrappedTypeCode)
      if (type) {
        const res = await srsp.qcGetPageScrappedReason(1, -1, type.id)
        record.scrapReasons = res.records
        this.scrapReasons = res.records
      }
    },
    handleDelete(key) {
      const dataSource = [...this.data]
      this.data = dataSource.filter((item) => item.key !== key)
      this.count -= 1
      this.$emit('changeData', this.data)
    },

    addScrap() {
      let num = 0
      this.data.forEach((res) => {
        num = res.scrappedNum + num
      })
      if (this.scrapNumber < 1) {
        this.$message.warning(this.$t('page_scrap_tip2'))
        return
      }
      if (num >= this.scrapNumber) {
        this.$message.warning(this.$t('page_scrap_tip3'))
        return
      }

      const dataSource = [...this.data]
      const newData = {
        key: this.count + 'add',
        scrappedNum: 0,
        scrappedReason: '',
        scrappedReasonCode: '',
        scrappedType: '',
        scrappedTypeCode: '',
        scrapReasons: []
      }
      this.count += 1
      this.data = [...dataSource, newData]
    }
  }
}
</script>

<template>
  <div>
    <ml-table
      size="small"
      :bordered="true"
      :columns="columns"
      :dataSource="data"
      :pagination="false"
      rowKey="id"
      style="margin-bottom: 4px"
    >
      <template slot="scrappedNum" slot-scope="text, record">
        <a-input-number
          style="margin: -5px 0;width: 200px"
          :value="text"
          @change="(value) => handleChange(value, record.key, 'scrappedNum')"
        />
      </template>
      <template slot="scrappedType" slot-scope="text, record">
        <a-select
          show-search
          optionFilterProp="children"
          :value="record.scrappedTypeCode"
          style="width: 200px"
          @change="(e) => handleChange(e, record.key, 'scrappedType')"
        >
          <template v-for="(res, index) in scrapType">
            <a-select-option :key="index" :value="res.code"
              >{{ res.name }}-{{ res.code }}</a-select-option
            >
          </template>
        </a-select>
      </template>
      <template slot="scrappedReason" slot-scope="text, record">
        <a-select
          show-search
          optionFilterProp="children"
          :value="record.scrappedReasonCode"
          style="width: 200px"
          @dropdownVisibleChange="() => getReasons(record)"
          @change="(e) => handleChange(e, record.key, 'scrappedReason')"
        >
          <template v-for="(res, index) in record.scrapReasons">
            <a-select-option :key="index" :value="res.code"
              >{{ res.reason }}-{{ res.code }}</a-select-option
            >
          </template>
        </a-select>
      </template>
      <template slot="action" slot-scope="text, record">
        <a-popconfirm
          :title="$t('page_resource_pool_confirm_delete')"
          @confirm="() => handleDelete(record.key)"
          :okText="$t('yes')"
          :cancelText="$t('no')"
        >
          <a type="link" @click="(e) => e.stopPropagation()" class="del-color">
            {{ $t('delete') }}
          </a>
        </a-popconfirm>
      </template>
    </ml-table>
    <div>
      <a-button style="width:100%;" @click="() => this.addScrap()">{{$t('page_add_scrap')}}</a-button>
    </div>
  </div>
</template>

<style lang="scss" scoped></style>
